import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch, useHistory } from 'react-router-dom';
import { Box } from '@material-ui/core';

import { makeRoute } from 'core/router/router';
import { useActivate } from 'core/store/store';

import { OrderActionType } from 'state/order/actions';
import { orderNewListSelector } from 'state/order/selector';

import { OrderList, OrderListSorting } from 'components/OrderList/OrderList';
import { OrdersNewDialog } from './OrdersNewDialog';
import { OrdersNewEditDialog } from './OrdersNewEditDialog';

import { RoutePath } from 'RoutePath';

export interface OrdersNewProps {
    sorting: OrderListSorting;
}

export const OrdersNew = (props: OrdersNewProps) => {
    const history = useHistory();
    useActivate(OrderActionType.NEW_ORDERS_ACTIVATE, OrderActionType.NEW_ORDERS_DEACTIVATE);
    const items = useSelector(orderNewListSelector);
    return (
        <Fragment>
            <Box m={2} pb={6}>
                <OrderList
                    orders={items}
                    sorting={props.sorting}
                    onClick={(storeId, orderId) => {
                        const path = makeRoute(RoutePath.ORDERS_NEW_DIALOG, { orderId });
                        history.push(path);
                    }}
                />
            </Box>
            <Switch>
                <Route exact={true} path={RoutePath.ORDERS_NEW_DIALOG}>
                    <OrdersNewDialog />
                </Route>
                <Route exact={true} path={RoutePath.ORDERS_NEW_DIALOG_EDIT}>
                    <OrdersNewEditDialog />
                </Route>
            </Switch>
        </Fragment>
    );
};
